import React, {Component} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Button, Input, DatePicker, Card} from "antd";
import StandardTable from "../../components/StandardTable";
import * as api from "../../api/product_location";

class TemporaryLocationLog extends Component {
    dataTable = undefined

    state = {
        searchKeyword: null,
        dateRange: null
    }

    columns = [
        {
            title: '采购订号',
            dataIndex: 'purchase_no',
        },
        {
            title: '行号',
            dataIndex: 'line_no',
        },
        {
            title: '库位编号',
            dataIndex: 'location_no',
        },
        {
            title: '数量',
            dataIndex: 'qty',
        },
        {
            title: '操作人',
            dataIndex: 'created_name',
        },
        {
            title: '时间',
            dataIndex: 'created_time',
        },
    ]

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visible !== this.props.visible && this.props.visible && this.dataTable) {
            this.dataTable.fetch()
        }
    }

    handleExport = () => {
        api.exportTemporaryLocationLog(this.state.searchKeyword, this.state.dateRange).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '自由库位日志.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    render() {
        return (
            <PageHeaderLayout>
                <Card>
                    <div style={{textAlign: 'center'}}>
                        <Input.Search style={{width: 500}}
                                      enterButton="搜索"
                                      onSearch={(value) => this.setState({searchKeyword: value})}
                        />
                    </div>
                    <br/>
                    <div>
                        <Button type={"primary"} onClick={this.handleExport}>导出</Button>
                        <DatePicker.RangePicker style={{marginLeft: 15}} value={this.state.dateRange}
                                                onChange={date => {
                                                    this.setState({dateRange: date}, () => {
                                                        this.dataTable.fetch()
                                                    })
                                                }}/>
                    </div>
                    <br/>
                    <StandardTable columns={this.columns}
                                   rowKey={'id'}
                                   requestMethod={'post'}
                                   ref={(table) => this.dataTable = table}
                                   url={'/api/temporary/location/log'}
                                   keyword={this.state.searchKeyword}
                                   filters={{
                                       dateRange: this.state.dateRange
                                   }}
                    />
                </Card>
            </PageHeaderLayout>
        )
    }
}

export default TemporaryLocationLog;
